<script setup>
import ActionButton from "@/components/ui/ActionButton.vue";

function openChat() {
  window.open('https://t.me/deedcoin_club', '_blank');
}
</script>

<template>
  <div class="telegramChat">
    <div class="telegramChat__main">
      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" fill="none" flex-shrink="0">
        <path fill="currentColor"
              d="M23.994 6.627c-.333 3.337-1.772 11.45-2.503 15.189-.31 1.584-.93 2.112-1.507 2.176-1.284.105-2.259-.803-3.5-1.585-.98-.616-1.747-1.115-2.507-1.608-.751-.489-1.496-.973-2.432-1.56-1.897-1.189-1.092-1.918-.022-2.887.166-.15.34-.307.51-.473.06-.057.292-.263.635-.566 1.559-1.378 5.387-4.752 5.478-5.116a.4.4 0 0 0-.11-.38c-.134-.106-.31-.064-.466-.043-.2.043-3.3 2.007-9.347 5.894-.886.57-1.684.866-2.392.845-.798-.02-2.304-.422-3.434-.781-1.395-.423-2.48-.655-2.392-1.395.044-.38.598-.76 1.64-1.162 6.467-2.682 10.764-4.457 12.913-5.302C20.715 5.423 21.978 5 22.82 5c.177 0 .598.042.863.253a.83.83 0 0 1 .31.57c-.021.128.023.508 0 .804"/>
      </svg>
      <span class="telegramChat__caption">Телеграм чат клуба</span>
    </div>
    <ActionButton icon-type="arrow" @buttonClick="openChat">
      <template #caption>Вступить</template>
    </ActionButton>
  </div>
</template>

<style scoped lang="scss">
.telegramChat {
  padding: 24px;
  width: 263px;
  min-height: 180px;
  border-radius: 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  background-color: var(--cd-card-bg);
  color: var(--cd-text);

  // На планшете: горизонтальный, фиксированная ширина (tools теперь под всей сеткой)
  @include respond-to('lg') {
    min-height: auto;
    flex-direction: row;
    align-items: center;
    width: fit-content;
    max-width: 100%;
  }

  @include respond-to('md') {
    width: 100%;
  }

  &__main {
    display: flex;
    align-items: flex-start;
    gap: 10px;

    svg { flex-shrink: 0; }
  }

  &__caption {
    font-family: var(--cd-bold-font);
    font-weight: 500;
    font-size: 20px;
    text-align: left;
  }
}
</style>
